import { initReactI18next } from 'react-i18next'
import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import gitInfo from '~root/git-info.json'
import format from './format'

const version =
  (import.meta.env.NODE_ENV === 'production' && gitInfo.commitHash) ||
  new Date().getTime()

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: 'pl',
    fallbackLng: 'pl',
    supportedLngs: ['pl'],
    interpolation: {
      escapeValue: false,
      format,
    },
    react: {
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'em'],
    },
    saveMissing: true, // send not translated keys to endpoint
    backend: {
      // allow cross domain requests
      crossDomain: false,
      loadPath: `/{{lng}}/{{ns}}.json?cb=${version}`,
      addPath: `http://localhost:3010/locales/add/{{lng}}/{{ns}}.json`,
    },
  })

export default i18n
